import React from 'react';
import { getStoredReferralCode } from 'utils/referralStorage';

export default function ReferralSignupBanner() {
  const referralCode = getStoredReferralCode();
  if (!referralCode) {
    return null;
  }

  return (
    <div
      className="referral-signup-banner"
      role="status"
      style={{
        background: 'linear-gradient(180deg, rgba(250, 245, 255, 0.95), #ffffff)',
        border: '1px solid rgba(124, 58, 237, 0.18)',
        borderRadius: '12px',
        padding: '12px 14px',
        marginBottom: '16px',
        color: '#4c1d95',
        fontSize: '0.95rem',
      }}
    >
      You were invited by another Lesson Launchpad teacher. Subscribe and you&apos;ll get one free month.
    </div>
  );
}
